<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  [attr.aria-labelledby]="'label.fareRulesDetail' | staticMsg"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head02">
      <h1
        id="modalTitle"
        class="p-modal-head02__title"
        [attr.aria-labelledby]="'reader.itineraryFareRulesDetail' | staticMsg"
      >
        {{ 'label.fareRulesDetail' | staticMsg }}
      </h1>
      <button
        class="p-modal-head02__close js-modal-close"
        id="p-fare-condition-details-header-btn"
        (click)="clickClose()"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>
  <div #modalBody [class]="lmodalBodyClass">
    <!-- [1.10.1] 運賃ルール詳細モーダル -->
    <asw-fare-rule-slider id="fare-rules-deatils-slider">
      <div class="p-modal-body05" *ngIf="showContentModal">
        <div class="slider-frame01" #scrollPanel>
          <div class="p-fare-rule-detail-panel">
            <ng-container
              *ngFor="
                let conditionBound of payload?.fareConditions?.airOfferConditions?.airOfferConditionBounds;
                let i = index
              "
            >
              <div class="p-fare-rule-detail-panel__item">
                <div class="p-fare-rule-detail-panel__head">
                  <div class="p-fare-rule-detail-panel__head-airport">
                    <!-- [1.10.6] 出発地 -->
                    <span class="p-fare-rule-detail-panel__head-airport-departure">
                      {{ getPointOfDeparture(conditionBound) }}
                      <span class="p-fare-rule-detail-panel__head-airport-to">
                        <span aria-hidden="true" [innerHTML]="'label.hyphen' | staticMsg"></span>
                      </span>
                    </span>
                    <!-- /[1.10.6] 出発地 -->
                    <!-- [1.10.7] 到着地 -->
                    <span class="p-fare-rule-detail-panel__head-airport-arrival">
                      {{ getPlaceOfArrival(conditionBound) }}
                    </span>
                    <!-- /[1.10.7] 到着地 -->
                  </div>
                </div>
                <div class="p-fare-rule-detail-panel__body">
                  <ng-container *ngFor="let traveler of payload?.orderData?.travelers">
                    <div class="p-fare-rule-detail-panel__body-item">
                      <!-- [1.10.5] 搭乗者種別 -->
                      <div class="p-fare-rule-detail-panel__title">
                        <div
                          class="p-fare-rule-detail-panel__title-label p-fare-rule-detail-panel__title-label--em"
                          [innerHTML]="getPassengerTypeConvertLabel(traveler)"
                        ></div>
                        <div
                          class="p-fare-rule-detail-panel__title-lead"
                          [innerHTML]="'label.perPerson' | staticMsg"
                        ></div>
                      </div>
                      <!-- /[1.10.5] 搭乗者種別 -->

                      <dl class="c-def-list02">
                        <div class="c-def-list02__item">
                          <!-- [1.10.24] FF名称ラベル -->
                          <dt
                            class="c-def-list02__item-title"
                            aria-hidden="true"
                            [innerHTML]="ffNameLabel | staticMsg"
                          ></dt>
                          <!-- /[1.10.24] FF名称ラベル -->
                          <dd class="c-def-list02__item-body">
                            <dl class="c-float-list01">
                              <div class="c-float-list01__item">
                                <dt class="c-float-list01__title" [innerHTML]="'label.fareName' | staticMsg"></dt>
                                <dd
                                  class="c-float-list01__contents c-float-list01__contents--fs16"
                                  *ngIf="checkFareSection(conditionBound)"
                                >
                                  <!-- [1.10.8] FF名称 -->
                                  <div
                                    class="c-float-list01__contents-item c-float-list01__contents-item--em"
                                    [innerHTML]="ffName"
                                  ></div>
                                  <!-- [1.10.8] FF名称 -->

                                  <div class="c-float-list01__contents-item c-float-list01__contents-item--normal">
                                    <!-- [1.10.9] Fare Basis 運賃基準 -->
                                    {{ fBasis }}
                                    <br *ngIf="fBasis !== ''" />
                                    <!-- /[1.10.9] Fare Basis 運賃基準 -->
                                    <!-- [1.10.11] 運賃詳細リンク -->
                                    <div
                                      class="c-float-list01__link"
                                      id="fares-details-link"
                                      [innerHTML]="fareDetailsLink(conditionBound) | staticMsg"
                                    ></div>
                                    <!-- /[1.10.11] 運賃詳細リンク -->
                                  </div>
                                </dd>
                              </div>
                            </dl>
                          </dd>
                        </div>

                        <!-- [1.10.12] 変更ルール -->
                        <div class="c-def-list02__item" *ngIf="showChangeCondition(i, traveler?.passengerTypeCode)">
                          <dt class="c-def-list02__item-title" [innerHTML]="'label.changeItinerary' | staticMsg"></dt>
                          <dd class="c-def-list02__item-body">
                            <dl class="c-float-list01">
                              <ng-container
                                *ngFor="let changeCondition of getChangeCondition(i, traveler?.passengerTypeCode)"
                              >
                                <div class="c-float-list01__item">
                                  <dt class="c-float-list01__title" [innerHTML]="'label.beforeDep' | staticMsg"></dt>
                                  <!-- [1.10.13] 出発前 -->
                                  <dd
                                    class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                                    [innerHTML]="getBeforeDeparture(changeCondition)"
                                  ></dd>
                                  <!-- /[1.10.13] 出発前 -->
                                </div>
                                <div class="c-float-list01__item">
                                  <dt
                                    class="c-float-list01__title"
                                    [innerHTML]="'label.beforeDepNoShow' | staticMsg"
                                  ></dt>
                                  <!-- [1.10.14] no show -->
                                  <dd
                                    class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                                    [innerHTML]="getBeforeDepartureNoShow(changeCondition)"
                                  ></dd>
                                  <!-- /[1.10.14] no show -->
                                </div>
                                <div class="c-float-list01__item">
                                  <dt class="c-float-list01__title" [innerHTML]="'label.afterDep' | staticMsg"></dt>
                                  <!-- [1.10.15] 一部搭乗済み -->
                                  <dd
                                    class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                                    [innerHTML]="getAfterDeparture(changeCondition)"
                                  ></dd>
                                  <!-- /[1.10.15] 一部搭乗済み -->
                                </div>
                                <div class="c-float-list01__item">
                                  <dt
                                    class="c-float-list01__title"
                                    [innerHTML]="'label.afterDepNoShow' | staticMsg"
                                  ></dt>
                                  <!-- [1.10.16] no show(一部搭乗済み) -->
                                  <dd
                                    class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                                    [innerHTML]="getAfterDepartureNoShow(changeCondition)"
                                  ></dd>
                                  <!-- /[1.10.16] no show(一部搭乗済み) -->
                                </div>
                              </ng-container>
                            </dl>
                          </dd>
                        </div>
                        <!-- /[1.10.12] 変更ルール -->

                        <!-- [1.10.17] 払戻ルール -->
                        <div class="c-def-list02__item" *ngIf="showRefundCondition(i, traveler?.passengerTypeCode)">
                          <dt class="c-def-list02__item-title" [innerHTML]="'label.refund' | staticMsg"></dt>
                          <dd class="c-def-list02__item-body">
                            <dl class="c-float-list01">
                              <ng-container
                                *ngFor="let refundCondition of getRefundCondition(i, traveler?.passengerTypeCode)"
                              >
                                <div class="c-float-list01__item">
                                  <dt class="c-float-list01__title" [innerHTML]="'label.beforeDep' | staticMsg"></dt>
                                  <!-- [1.10.18] 出発前 -->
                                  <dd
                                    class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                                    [innerHTML]="getBeforeDepartureRefund(refundCondition)"
                                  ></dd>
                                  <!-- /[1.10.18] 出発前 -->
                                </div>
                                <div class="c-float-list01__item">
                                  <dt
                                    class="c-float-list01__title"
                                    [innerHTML]="'label.beforeDepNoShow' | staticMsg"
                                  ></dt>
                                  <!-- [1.10.19] no show -->
                                  <dd
                                    class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                                    [innerHTML]="getBeforeDepartureNoShowRefund(refundCondition)"
                                  ></dd>
                                  <!-- /[1.10.19] no show -->
                                </div>
                                <div class="c-float-list01__item">
                                  <dt class="c-float-list01__title" [innerHTML]="'label.afterDep' | staticMsg"></dt>
                                  <!-- [1.10.20] 一部搭乗済み -->
                                  <dd
                                    class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                                    [innerHTML]="getAfterDepartureRefund(refundCondition)"
                                  ></dd>
                                  <!-- /[1.10.20] 一部搭乗済み -->
                                </div>
                                <div class="c-float-list01__item">
                                  <dt
                                    class="c-float-list01__title"
                                    [innerHTML]="'label.afterDepNoShow' | staticMsg"
                                  ></dt>
                                  <!-- [1.10.21] no show(一部搭乗済み) -->
                                  <dd
                                    class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                                    [innerHTML]="getAfterDepartureNoShowRefund(refundCondition)"
                                  ></dd>
                                  <!-- /[1.10.21] no show(一部搭乗済み) -->
                                </div>
                              </ng-container>
                            </dl>
                          </dd>
                        </div>
                        <!-- /[1.10.17] 払戻ルール -->
                      </dl>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </asw-fare-rule-slider>
    <!-- /[1.10.1] 運賃ルール詳細モーダル -->
  </div>
</div>
